import React from 'react';
import { StyledActionButton } from './style';

export default props => <StyledActionButton {...props} />;
